/* ============================================================
   WhatsApp flotante · Daza Organic
   Tres comportamientos: cuándo sale el globo, recordar que lo
   cerraron y esconder el botón al bajar.

   El cierre se guarda en sessionStorage, no en localStorage: la
   idea es «no insistir en esta visita», no «no volver nunca».
   ============================================================ */
(function () {
  'use strict';

  function arranca(raiz) {
    if (raiz.dataset.waListo) return;
    raiz.dataset.waListo = '1';

    var id = raiz.dataset.dazaWa || 'wa';
    var globo = raiz.querySelector('[data-globo]');
    var cerrar = raiz.querySelector('[data-cerrar]');
    var clave = 'daza-wa-cerrado:' + id;
    var cerrado = false;

    try {
      cerrado = sessionStorage.getItem(clave) === '1';
    } catch (e) {
      /* Modo privado o cookies bloqueadas: se sigue sin memoria. */
    }

    // ── Globo ────────────────────────────────────────────────
    if (globo && !cerrado) {
      var disparador = raiz.dataset.disparador || 'espera';
      var espera = parseInt(raiz.dataset.espera, 10);
      if (isNaN(espera)) espera = 6;

      var muestra = function () {
        if (cerrado) return;
        globo.hidden = false;
      };

      if (disparador === 'carga') {
        muestra();
      } else if (disparador === 'scroll') {
        var alBajar = function () {
          if (window.scrollY > window.innerHeight * 0.5) {
            muestra();
            window.removeEventListener('scroll', alBajar);
          }
        };
        window.addEventListener('scroll', alBajar, { passive: true });
        alBajar();
      } else {
        window.setTimeout(muestra, espera * 1000);
      }
    }

    if (cerrar && globo) {
      cerrar.addEventListener('click', function () {
        cerrado = true;
        globo.hidden = true;
        try {
          sessionStorage.setItem(clave, '1');
        } catch (e) {
          /* sin memoria disponible: el globo simplemente no vuelve en esta carga */
        }
      });
    }

    // ── Esconder al bajar ────────────────────────────────────
    if (raiz.dataset.ocultar === 'true') {
      var ultimo = window.scrollY;
      var pendiente = false;

      var revisa = function () {
        var y = window.scrollY;
        // Arriba del todo siempre visible: si no, el botón no vuelve nunca
        // cuando la página es más corta que el umbral.
        if (y < 80) {
          delete raiz.dataset.oculto;
        } else if (y > ultimo + 6) {
          raiz.dataset.oculto = '';
        } else if (y < ultimo - 6) {
          delete raiz.dataset.oculto;
        }
        ultimo = y;
        pendiente = false;
      };

      window.addEventListener(
        'scroll',
        function () {
          if (pendiente) return;
          pendiente = true;
          window.requestAnimationFrame(revisa);
        },
        { passive: true }
      );
    }
  }

  function todos() {
    document.querySelectorAll('[data-daza-wa]').forEach(arranca);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else {
    todos();
  }

  // El editor recarga la sección sin recargar la página.
  document.addEventListener('shopify:section:load', todos);
})();
